import { render } from "./Switch.vue?vue&type=template&id=78ae8f6a&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=78ae8f6a&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ae8f6a"]])

export default __exports__